import React from 'react';
import './exhibitorCategory.css';

const ExhibitorCategory = (props) => {
    return ( 
        <>
        <div className="exhibitorCategory">
            <h6>{props.exhibitorCategory}</h6>
            </div>
        </>
     );
}
 
export default ExhibitorCategory;